module.exports = __webpack_public_path__ + "img/观看.eba97692.svg";